import React from 'react';
import randomstring from 'uuid/v4';
import TextField from '@material-ui/core/TextField';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import { TrashIcon } from '../../../images/icons/WrapSvg';
import BlueButton from '../../buttons/BlueButton';
import Back from './backstep';

function init(id) {
    return {
        id: id,
        nombre: "",
        nivel: 10
    }
}

class Team extends React.Component {

    state = {
        isLoading: false,
        save: false,
        current: init(randomstring())
    }

    handleChangeCurrent = event => {
        const { current } = this.state;
        current[event.target.name] = event.target.value;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleClick = index => event => {
        const { current } = this.state;
        current['nivel'] = index;
        this.setState({ current: JSON.parse(JSON.stringify(current)) })
    }

    handleAdd = event => {
        if (this.ready()) {
            let { onboarding } = this.props;
            const { current } = this.state;
            if (!onboarding.roles) {
                onboarding.roles = [];
            }
            current.id = randomstring();
            onboarding.roles.push({ ...current });
            this.props.onSave('roles', onboarding.roles);
            this.setState({
                save: false,
                current: init(randomstring())
            })
        }
    }

    handleEdit = index => event => {
        this.setState({ save: index, current: this.props.onboarding.roles[index] })
    }

    handleSave = event => {
        let { onboarding } = this.props;
        const { current, save } = this.state;
        onboarding.roles[save] = current;
        this.props.onSave('roles', onboarding.roles);
        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring())))
        })
    }

    handleDelete = index => event => {
        let { onboarding } = this.props;
        const { usuarios } = onboarding;

        const id = onboarding.roles[index].id;

        let temp = usuarios.reduce((arr, i) => {
            if (i.puesto !== id) {
                arr.push(i);
            }
            return arr;
        }, []);

        this.props.onSave('usuarios', temp);

        onboarding.roles.splice(index, 1);
        this.props.onSave('roles', onboarding.roles);


        this.setState({
            save: false,
            current: JSON.parse(JSON.stringify(init(randomstring())))
        })
    }

    ready = () => {
        const { current } = this.state;
        return current.nombre
            && current.nivel;
    }

    render() {
        const { current, save } = this.state;
        const { intl, onboarding } = this.props;
        const { roles } = onboarding;
        const stars = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

        console.log(current['nivel']);

        return (
            <div className="ob_step">
                <Back {...this.props} />
                <div className="flex_full_row padding_borders_flat center">
                    <div className="ob_welcome text_align_left_important">
                        <div className="ob_locals padding_top_12">
                            {(roles && roles.length > 0) &&
                                roles.map((i, index) =>
                                    <div key={'team_bt_' + index} className="flex_auto_row margin_right_12">
                                        <div className="ob_local_button" onClick={this.handleEdit(index)}>
                                            <div className="flex_full_row width100 elements_from_right align_center margin_bottom_12">
                                                <div className="flex_full_row width100  align_center ob_local_bt_index">
                                                    <Star className="ob_local_bt_trash c_pea" />
                                                    {i.nivel}
                                                </div>
                                            </div>
                                            <span className="ob_local_button_title hand">{i.nombre}</span>
                                        </div>
                                        <div className="ob_trash">
                                            <TrashIcon
                                                className="hand ob_local_bt_trash"
                                                color={'secondary'}
                                                onClick={this.handleDelete(index)}
                                            />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="flex_auto_row width100 align_baseline margin_top_24">
                            <TextField
                                fullWidth
                                id={'nombre'}
                                name={'nombre'}
                                required
                                label={intl.formatMessage({ id: 'ob_job_title' })}
                                className={'flex_full_row margin_bottom_12'}
                                value={current.nombre ? current.nombre : ''}
                                onChange={this.handleChangeCurrent}
                                margin="normal"
                            />
                        </div>
                        <div className="flex_auto_column width100 margin_top_12 margin_bottom_12 ">
                            <span className="ob_job_level text_align_left">{intl.formatMessage({ id: 'ob_job_level' })}</span>
                            <span className="ob_job_level_subtitle text_align_left margin_top_12">{intl.formatMessage({ id: 'ob_job_level_info' })}</span>
                        </div>
                        <div className="flex_auto_row width100 align_center elements_separated">
                            {stars.map((i) => {
                                if (current['nivel'] <= i) {
                                    return <Star key={'star' + i} className="ob_job_font_size c_pea" onClick={this.handleClick(i)} />;
                                } else {
                                    return <StarBorder key={'star' + i} className="ob_job_font_size c_pea" onClick={this.handleClick(i)} />;
                                }
                            })
                            }
                        </div>
                        <div className="flex_auto_row width100 align_center ob_job_level_subtitle margin_top_12 margin_bottom_32 ">
                            {intl.formatMessage({ id: 'ob_job_level_subtitle' })}
                        </div>
                        <div className="flex_auto_row width100 align_center elements_from_right">
                            {save !== false &&
                                <button className={"ob_add margin_right_12 " + (!this.ready() ? 'c_disabled' : 'c_slate')} onClick={this.handleSave} >
                                    {intl.formatMessage({ id: 'ob_save' })}
                                </button>
                            }
                            <button className={"ob_add " + (!this.ready() ? 'c_disabled' : 'c_slate')} onClick={this.handleAdd} >
                                {intl.formatMessage({ id: 'ob_add' })}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="flex_auto_row width100 padding_borders_flat elements_from_right">
                    <BlueButton id="next" className="ob_next" onClick={this.props.onNext} />
                </div>
            </div>
        );



    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/team.js